import styled from 'styled-components';

export const PrinterDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  transition: all 0.35s ease-in-out;
`;
